import React, { CSSProperties } from "react";
import { Button } from "react-bootstrap";

interface BasicButtonProps {
  children: React.ReactNode;
  onClick?: () => void;
  type?: "button" | "submit" | "reset";
  className?: string;
  disabled?: boolean;
  variant?: "basic" | "ghost";
  size?: "sm" | "md";
}

// Shared shape so "basic" and "ghost" render at the same size. "sm" is for
// buttons embedded in dense contexts like table rows.
const SIZE_STYLES: Record<"sm" | "md", CSSProperties> = {
  md: { padding: "10px 20px", borderRadius: 16, fontSize: 16 },
  sm: { padding: "6px 14px", borderRadius: 12, fontSize: 14 },
};

// Colors owned here instead of the shared, !important-heavy .btnBlue class, so
// size/shape stay fully under this component's control.
const VARIANT_STYLES: Record<"basic" | "ghost", CSSProperties> = {
  basic: { backgroundColor: "var(--primary-color)", borderColor: "transparent", color: "var(--white-color)" },
  ghost: {},
};

const VARIANT_CLASSES: Record<"basic" | "ghost", string> = {
  basic: "",
  ghost: "bg-white text-muted border border-secondary",
};

const BasicButton: React.FC<BasicButtonProps> = (props) => {
  const { children, onClick, type = "button", className, disabled, variant = "basic", size = "md" } = props;

  const classes = `${VARIANT_CLASSES[variant]} ${className || ""}`;
  const style: CSSProperties = { ...SIZE_STYLES[size], ...VARIANT_STYLES[variant] };

  return (
    <Button type={type} className={classes} style={style} onClick={onClick} disabled={disabled}>
      {children}
    </Button>
  );
};

export default BasicButton;
